import React, { useMemo } from 'react';

import { useDeps } from 'src/hooks/useEpicDeps';

const YOTPO_SCRIPT_URL = 'https://cdn-widgetsrepository.yotpo.com/v1/loader/';

export function YotpoScript() {
    const { YOTPO_API_KEY, YOTPO_ENABLED } = useDeps().env;

    const yotpoScriptUrl = useMemo(() => YOTPO_SCRIPT_URL + YOTPO_API_KEY, [YOTPO_API_KEY]);

    if (!YOTPO_ENABLED) {
        return null;
    }

    return <script id="yotpo-script" src={yotpoScriptUrl} async></script>;
}

export default YotpoScript;
